<template>
    <div
        class="question-answer"
        itemscope
        itemprop="mainEntity"
        itemtype="https://schema.org/Question"
        :class="{active: show}"
    >
        <div
            @click="toggle"
            class="question"
        >
            <div
                class="question-text"
                itemprop="name"
                v-html="question"
            />
            <span class="question-icon">
                <transition
                    name="spin"
                    mode="out-in"
                >
                    <i :class="icon" />
                </transition>
            </span>
        </div>

        <transition name="faq">
            <div
                v-show="show"
                class="answer"
                itemscope itemprop="acceptedAnswer"
                itemtype="https://schema.org/Answer"
            >
                <div
                    class="answer-text"
                    itemprop="text"
                    v-html="answer"
                />
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            question: {
                type: String,
                required: true
            },
            answer: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false,
                default: 'fas fa-chevron-down'
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            toggle() {
                this.show = !this.show;
            }
        }
    }
</script>
<style lang="scss">
    .question-answer {
        display: flex;
        flex-wrap: wrap;

        .question {
            width: 100%;
            cursor: pointer;
            display: flex;
            justify-content: space-between;

            &-text {
                flex: 1;
            }
            &-icon {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .answer {
            width: 100%;
        }
    }
</style>
